import React from "react"
import styled from "styled-components"

import { PrimaryButton } from "components/buttons"
import { Flex } from "components/box"
import { ParagraphLarge } from "components/text"

export type PlanSummaryFooterProps = {
  hasAddedProduct?: boolean
  subtotal?: string
  onContinue?: (event?: React.MouseEvent) => void
}

const Container = styled(Flex).attrs({
  flexDirection: "column",
  bottom: 0,
  width: "100%",
  position: ["fixed", null, "initial"],
  mb: [3, null, 5],
  px: [5, null, 0]
})`
  background-color: ${props => props.theme.colors.white};

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}px) {
    background-color: ${props => props.theme.colors.lightSalmon};
  }
`

const SeparatorMobile = styled.hr`
  position: absolute;
  border: 2px solid ${props => props.theme.colors.iceBlue};
  border-width: 0.0625rem;
  width: 100%;
  margin: 0;
  left: 0;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}px) {
    display: none;
  }
`

const InitialPlanSummaryFooter = () => <></>

const AddedProductPlanSummaryFooter: React.FC<PlanSummaryFooterProps> = ({ subtotal, onContinue }) => (
  <Container>
    <SeparatorMobile />
    <Flex mt={["0.625rem", null, 0]} mb="0.625rem" justifyContent="space-between">
      <ParagraphLarge color="Gunmetal">Subtotal</ParagraphLarge>
      {subtotal && (
        <ParagraphLarge color="astralBlue" bold>
          {subtotal}
        </ParagraphLarge>
      )}
    </Flex>
    <PrimaryButton sizing="stretch" noShadow color="astralBlue" onClick={onContinue} mr={6}>
      Continue
    </PrimaryButton>
  </Container>
)

export const PlanSummaryFooter: React.FC<PlanSummaryFooterProps> = ({
  hasAddedProduct = false,
  subtotal,
  onContinue
}) => {
  if (hasAddedProduct) {
    return <AddedProductPlanSummaryFooter subtotal={subtotal} onContinue={onContinue} />
  }

  return <InitialPlanSummaryFooter />
}
